import { Controller } from "@hotwired/stimulus";

// Scrolls to #comment-{id} after load. Schedules multiple scrolls to override
// the browser’s default “scroll to top” on navigation. Attach with
// data-controller="scroll-to-comment" data-scroll-to-comment-comment-id-value="123"
export default class extends Controller {
  static values = {
    commentId: String,
  };

  connect() {
    const id = this.commentIdValue;
    if (!id) return;

    const el = document.getElementById(`comment-${id}`);
    if (!el) return;

    history.scrollRestoration = "manual";

    const scroll = () =>
      el.scrollIntoView({ behavior: "auto", block: "center" });

    scroll();
    [50, 150, 350, 700].forEach((ms) => setTimeout(scroll, ms));
    window.addEventListener("load", () => setTimeout(scroll, 50));
  }
}
